import React from "react";
import { Outlet } from "react-router-dom";

export default function AdminLayout() {
  return (
    <div style={{ minHeight: "100vh", background: "#0f172a", color: "#fff" }}>
      <div style={{ padding: "20px 40px", borderBottom: "1px solid #1e293b" }}>
        <h2>Admin Panel</h2>
      </div>

      <div style={{ padding: 20 }}>
        <Outlet />
      </div>
    </div>
  );
}
